import { useMemo } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import PageMeta from "@/components/feature/PageMeta";
import PosterCard from "@/components/feature/PosterCard";
import { titles } from "@/lib/catalog";
import { useFavorites } from "@/lib/favorites";

export default function FavoritesPage() {
  const { favorites } = useFavorites();
  const items = useMemo(() => titles.filter((t) => favorites.includes(t.id)), [favorites]);

  return (
    <>
      <PageMeta
        title="我的收藏 - 在线观看日韩影视作品 -日韩在线"
        description="查看你在日韩在线收藏的影视作品，收藏数据保存在当前浏览器本地，刷新或再次访问依然可以查看。"
        keywords="我的收藏,日韩影视收藏,日韩电影收藏,日韩电视剧收藏"
        noindex
      />
      <SiteLayout topOffset>
        <section className="w-full bg-primary-950">
          <div className="w-full px-4 md:px-8 py-10 md:py-12">
            <nav className="flex items-center gap-1.5 text-xs text-background-200/70 flex-wrap" aria-label="面包屑">
              <Link to="/" className="hover:text-background-50 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line w-3.5 h-3.5 flex items-center justify-center" />
              <span className="text-background-50">我的收藏</span>
            </nav>
            <h1 className="mt-5 font-heading text-2xl md:text-3xl font-black text-background-50 tracking-tight">
              我的收藏
            </h1>
            <p className="mt-2 text-sm text-background-200/75 max-w-2xl leading-relaxed">
              已收藏 <span className="font-label font-bold text-accent-400">{items.length}</span> 部影视。
              收藏记录保存在当前浏览器本地存储中，不需要登录，清除浏览器数据后将不再保留。
            </p>
          </div>
        </section>

        <section className="w-full px-4 md:px-8 py-8 md:py-10">
          {items.length === 0 ? (
            <div className="rounded-lg border border-dashed border-background-300 bg-background-100 py-20 text-center px-4">
              <span className="w-14 h-14 rounded-full bg-background-200 text-foreground-400 flex items-center justify-center mx-auto">
                <i className="ri-heart-3-line text-2xl w-6 h-6 flex items-center justify-center" />
              </span>
              <h2 className="mt-4 font-heading text-base font-bold text-foreground-900">还没有收藏任何影视</h2>
              <p className="mt-1.5 text-xs text-foreground-500">在影视卡片或详情页点击收藏按钮，就能在这里看到它们。</p>
              <div className="mt-5 flex items-center justify-center gap-2 flex-wrap">
                <Link
                  to="/category/movie"
                  className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-600 text-background-50 text-xs font-label font-semibold whitespace-nowrap hover:bg-primary-700 transition-colors"
                >
                  去看电影
                </Link>
                <Link
                  to="/category/drama"
                  className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md border border-background-300 text-foreground-800 text-xs font-label font-semibold whitespace-nowrap hover:bg-background-200 transition-colors"
                >
                  去看电视剧
                </Link>
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-7 md:gap-x-5 md:gap-y-9">
              {items.map((item) => (
                <PosterCard key={item.id} item={item} />
              ))}
            </div>
          )}
        </section>
      </SiteLayout>
    </>
  );
}